// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3K5p5","options":"AnswerScale_options__12qUt","selected":"AnswerScale_selected__3wCbU"};